module.exports = "<message></message>\n<div class=\"c-dashboard--arrivals c-arrivals\">\n\n    <header class=\"c-page-head\">\n        <div class=\"c-dashboard__welcome\">\n            <h2>Guest Arrivals</h2>\n        </div>\n    </header>\n\n    <main>\n        <div class=\"row\">\n            <div class=\"small-12 columns\">\n                <arrival-list arrivals=\"$ctrl.today\" date=\"today\"></arrival-list>\n\n                <arrival-list arrivals=\"$ctrl.tomorrow\" date=\"tomorrow\"></arrival-list>\n            </div>\n        </div>\n    </main>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./frontend/admin/app/modules/guests/views/arrival.dashboard.html
// module id = 863
// module chunks = 0